// helper which creates specific download logic
// it's similar to GET, but we don't allow triggering new download until current one completes
import startCase from 'lodash.startcase'
import to from 'await-to-js'
import fileSaver from 'file-saver'
import { mimeTypes, defaultExtension } from './mimeTypes'

import {
  addRequestAuthentication,
  addRequestFiltering,
  invokeHooks,
  pascalCase,
  promisifyRPC
} from '../utils'

export default ({ actionType, name, config, common }) => {
  let fn = async (context, params) => {
    // 1) prepare request object
    // - convention: uppercase first letter of name + add 'Request'
    let requestObjectType = `${pascalCase(name)}Request`
    let request = new config.service.import[requestObjectType]()
    // - add authentication
    addRequestAuthentication(config, context, request, common.actionDefinitions[actionType][name].typeMappings)
    // - try to match other fields to allow filters: for example, request by uuid
    addRequestFiltering(config, context, request, params, common.actionDefinitions[actionType][name].typeMappings)
    // - ALLOW HOOK to change something within the request or make a whole new request
    request = await invokeHooks(actionType, 'beforeDataRequest', name, { config, context, request, params })
    // if request is now null - some error happened!
    if (!request) {
      return false
    }
    // 2) call API
    // save this request as the latest one (also sets error to null)
    context.commit('setLatestRequest', {
      name: name,
      masterActiveKey: context.state.masterActiveKey,
      request: request
    })
    // Invoke RPC and wait for it
    // - need to promisify GPRC call
    // - metadata is not used anywhere?
    let [err, data] = await to(promisifyRPC(config, name, request, context))
    // 3) GOT RESULTS
    if (err) {
      // push the error info into state, maybe we will show it to user
      context.dispatch('error', {
        message: `${startCase(name)}: Error while retrieving data.`,
        error: err
      })
      context.commit('setLatestRequestError', { name: name, error: err })
      await invokeHooks(actionType, 'error', name, { config, context, request, params, data: err })
      context.commit('finishedLatestRequest', name)
      return false
    }
    // extract items from the data object
    // we assume that everything is in place because no err happened
    let responseData = data.toObject()
    // store the whole response in the store
    context.commit('setLatestResponse', { name, responseData })
    // process the response and do the saving
    let fileName = responseData.filename || `download${defaultExtension}`
    let knownExtension = Object.keys(mimeTypes).find(ext => fileName.endsWith(ext))
    let fileMimeType
    if (knownExtension) {
      fileMimeType = mimeTypes[knownExtension]
    } else {
      // we take it as excel by default
      fileMimeType = mimeTypes[defaultExtension]
    }
    let fileData = data.array[0]
    let blob = new Blob([fileData], {
      type: `${fileMimeType};charset=utf-8`
    })
    fileSaver.saveAs(blob, fileName)
    // call hook if needed
    await invokeHooks(actionType, 'afterDataRequest', name, { config, context, request, params, data: responseData })
    // all done
    context.commit('finishedLatestRequest', name)
    return true
  }
  return fn
}
